module.exports = __webpack_public_path__ + "static/media/img_mcs_screen.c8b7c52c.png";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/img_mcs_screen.png
// module id = 365
// module chunks = 4